import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEgnyteComponent } from './simple-icons-egnyte.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEgnyteComponent ],
    exports:      [ SimpleIconsEgnyteComponent ],
    bootstrap:    []
})
export class SimpleIconsEgnyteModule {}
